import { render, staticRenderFns } from "./BasketSummary.vue?vue&type=template&id=eeb874a6"
import script from "./BasketSummary.vue?vue&type=script&lang=js"
export * from "./BasketSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports